import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-restricted-globals */
import { createContext, useState, useMemo, useEffect } from "react";
export const ConfirmationPageContext = createContext(null);
export const ConfirmationPageProvider = ({ children, }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [source, setSource] = useState(null);
    const [isSourceProgrammaticallySet, setIsSourceProgrammaticallySet] = useState(false);
    const [partnerTitles, setPartnerTitles] = useState([]);
    const cleanUrl = () => {
        // eslint-disable-next-line no-restricted-globals
        const url = new URL(window.location.href);
        url.searchParams.delete("view");
        url.searchParams.delete("origin");
        // eslint-disable-next-line no-restricted-globals
        window.history.replaceState({}, "", url.toString());
    };
    useEffect(() => {
        const syncFromUrl = () => {
            const params = new URLSearchParams(window.location.search);
            const view = params.get("view");
            const origin = params.get("origin");
            const isValidOrigin = origin === "form" || origin === "multi";
            if (view === "confirm" && isValidOrigin && isSourceProgrammaticallySet) {
                setShowConfirm(true);
                setSource(origin);
            }
            else {
                cleanUrl();
                setShowConfirm(false);
                setSource(null);
            }
        };
        syncFromUrl();
        window.addEventListener("popstate", syncFromUrl);
        return () => window.removeEventListener("popstate", syncFromUrl);
    }, [isSourceProgrammaticallySet]);
    const triggerConfirmView = (origin) => {
        // eslint-disable-next-line no-restricted-globals
        const url = new URL(window.location.href);
        url.searchParams.delete("modal");
        url.searchParams.set("view", "confirm");
        url.searchParams.set("origin", origin);
        window.history.replaceState({}, "", url.toString());
        setSource(origin);
        setIsSourceProgrammaticallySet(true);
        setShowConfirm(true);
    };
    const contextValue = useMemo(() => ({
        showConfirm,
        source,
        partnerTitles,
        triggerConfirmView,
        setPartnerTitles,
    }), [showConfirm, source, partnerTitles]);
    return (_jsx(ConfirmationPageContext.Provider, { value: contextValue, children: children }));
};
